import { SYSTEM_ANNOUNCEMENT_LOAD } from './systemAnnouncement.actionType';

import axios, { safeGet } from '../../axios-default';

const systemAnnouncementLoad = (payload) => ({
    type: SYSTEM_ANNOUNCEMENT_LOAD,
    payload,
});

export const loadSystemAnnouncement = () => async (dispatch) => {
    try {
        const systemAnnouncementRes = await axios.get('/systemannouncement');
        const { data } = systemAnnouncementRes;
        if (!data.success || data.anouncement.length > 1) throw new Error('System Announcement Error!');
        if (!data.anouncement.length) return;
        const announcementObj = {
            systemName: data.anouncement[0].system_name,
            startDateTime: data.anouncement[0].start_date_time,
            endDateTime: data.anouncement[0].end_date_time,
            information: data.anouncement[0].information,
        };

        await dispatch(systemAnnouncementLoad(announcementObj));
    } catch (err) {
        console.error(err);
    }
};
